import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GenericResolverResolver } from '@app/core/resolvers/generic-resolver.resolver';
import { Bac } from '@app/library/models/bac.model';
import { BacsState } from '@app/library/states/bacs.state';
import { Store } from '@ngxs/store';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LibraryBacsFindResolver extends GenericResolverResolver<Bac> {
  constructor(router: Router, store: Store) {
    super(
      router,
      store,
      'bacid',
      combineLatest([
        store.select(BacsState.hasAnyBacs),
        store.select(BacsState.isLoading).pipe(map(val => !val)),
      ]).pipe(map(arr => arr.reduce((prev, curr) => prev && curr, true))),
      BacsState.bacs,
    );
  }

  getUrl(currentRadioId: number): any[] {
    return ['radio', currentRadioId, 'media', 'bac', 1];
  }
}
/*
@Injectable({
  providedIn: LibraryModule,
})
export class LibraryBacsFindResolver implements Resolve<BacResolveParams> {
  constructor(private readonly router: Router, private readonly store: Store) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): BacResolveParams {
    const bacid = +route.paramMap.get('bacid');

    const bacObs: Observable<Bac> = combineLatest<[boolean, boolean]>(
      this.store.select(BacsState.hasAnyBacs),
      this.store.select(BacsState.isLoading).pipe(map(val => !val)),
    ).pipe(
      map(arr => arr.reduce((prev, curr) => prev && curr, true)),
      startWith(false),
      filter(val => val),
      mergeMap<any, [Bac[], number]>(() =>
        combineLatest(
          this.store.selectOnce(BacsState.bacs),
          this.store.selectOnce(RadioState.currentRadioId$),
        ),
      ),
      map(([bacs, currentRadioId$]) => {
        const foundBac = bacs.find(obj => obj.id === bacid);

        if (!foundBac) {
          this.redirectToBac(currentRadioId$, bacs[0].id);
          return bacs[0];
        }

        return foundBac;
      }),
      take(1),
    );
    return {
      currentBac: bacObs,
    };
  }

  redirectToBac(radioId: number, bacId: number) {
    this.router.navigate(['radio', radioId, 'media', 'bac', bacId]);
  }
}
*/
